<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <loading :active.sync="isPageLoading" is-full-page></loading>
        <div v-if="!isPageLoading">
          <div class="page-title">
            <h1>Owner Types</h1>
          </div>
          <div class="page-content">
            <form>
              <div class="form-group row">
                <label for="searchKeyword" class="col-sm-2 col-form-label">Search by Keyword</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="searchKeyword" />
                </div>
                <div class="col-sm-2">
                  <button type="button" class="btn btn-primary" @click="newOwnerType">
                    <i class="fas fa-plus-circle"></i> Add New
                  </button>
                </div>
              </div>
            </form>
            <ul class="list-group list-group-flush border-bottom">
              <li class="list-group-item d-flex px-2" v-for="ownerType in searchLocalDataset(getOwnerTypes)" :key="ownerType.id">
                <div class="mr-auto">
                  <p class="m-0">{{ ownerType.name }}</p>
                </div>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column"
                    title="Edit" @click.prevent="editOwnerType(ownerType.id)">
                  <img class="mb-1" src="@/assets/document.svg" alt />
                  <span class="small-grey">Edit</span>
                </a>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column ml-3 role-delete-trigger"
                    title="Delete" @click.prevent="deleteOwnerType(ownerType.id)">
                  <img class="mb-1" src="@/assets/red_x.svg" alt />
                  <span class="small-grey">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-owner-type" size="lg" hide-header hide-footer :no-close-on-backdrop="true">
      <owner-type></owner-type>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MessageBox from "@/utils/messagebox";
import Toast from "@/utils/toast";

export default {
  name: "configuration-owner-types",
  components: {
    'app-navbar': () => import('@/components/app-navbar.vue'),
    'owner-type': () => import('@/views/configuration/components/owner-type.vue')
  },
  computed: {
    ...mapGetters(["getOwnerTypes"])
  },
  data: function() {
    return {
      isPageLoading: true,
      searchKeyword: null,
    };
  },
  methods: {
    newOwnerType() {
      this.resetOwnerType().then(() => {
        this.$bvModal.show("bv-modal-owner-type");
      });
    },
    editOwnerType(id) {
      this.fetchOwnerType(id).then(() => {
        this.$bvModal.show("bv-modal-owner-type");
      });
    },
    async deleteOwnerType(id) {
      let confirm = await MessageBox.confirm(this, "Remove Owner Type", "Are you sure you want to remove owner type?");

      if (confirm) {
        this.removeOwnerType(id).then(() => {
          Toast.success(this, "Successfully removed owner type!");
        });
      }
    },
    searchLocalDataset(values) {
      if (!this.searchKeyword || this.searchKeyword === "") return values;

      return values.filter(i => i.name.includes(this.searchKeyword));
    },
    ...mapActions([ "fetchOwnerType", "fetchOwnerTypes", "removeOwnerType", "resetOwnerType" ])
  },
  created: function() {
    this.fetchOwnerTypes().then(() => {
      this.isPageLoading = false;
    });
  }
};
</script>
